export const moduleName = 'chatHistory'
